import { state, materialState, turkish } from "./../controls/state.js"
import { useSnapshot } from "valtio"
import React, { useRef, useState, useEffect, useLayoutEffect } from "react"
import { useGLTF } from "@react-three/drei"
import * as THREE from "three"
import * as mats from "./mats.js"

function Mercedes(props) {
    const group = useRef()
    
    const { scene, nodes, materials} = useGLTF("models/mercedes.glb")
    
    const custom = mats.getMaterial()

    /*
    Animation boilerplate
    //const { scene, nodes, materials, animations } = useGLTF("car.glb")

    // https://codesandbox.io/s/gltf-animations-pecl6?file=/src/Model.js
    // const { ref, actions, names } = useAnimations(animations)
    
    // There are animations but cant do useAnimations(), investigate later
    //console.log(animations)



    const { ref, mixer, names, actions, clips  } = useAnimations(animations)
    useEffect( () => {
      console.log(actions)
      if (actions.jump !== undefined){
        actions.jump.play();
      }
    })

    console.log("Animations: " , animations , "Mixer: " , mixer, "Clips: ", clips , "Names", names)

    const clip = THREE.AnimationClip.findByName( clips, names[0] );
    

    const mixer2 = new THREE.AnimationMixer(group);
    console.log("Clip:", clip)
    console.log("Mixer2", mixer2)
    const action = mixer2.clipAction( clip );

    
    useEffect(() => {
      actions.play()
    })
    
    */

    const snap = useSnapshot(state)
    const materialSnap = useSnapshot(materialState)
    const [hovered, set] = useState(null)
    useEffect(() => {
      const cursor = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><g filter="url(#filter0_d)"><path d="M29.5 47C39.165 47 47 39.165 47 29.5S39.165 12 29.5 12 12 19.835 12 29.5 19.835 47 29.5 47z" fill="${snap.items[hovered]}"/></g><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/><text fill="#000" style="white-space:pre" font-family="Inter var, sans-serif" font-size="10" letter-spacing="-.01em"><tspan x="35" y="63">${turkish[hovered]}</tspan></text></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath><filter id="filter0_d" x="6" y="8" width="47" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="3"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>`
      const auto = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/></svg>`
      document.body.style.cursor = `url('data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(hovered ? cursor : auto)))}'), auto`
    }, [hovered])  
   
    //console.log()
    //console.log(custom["c".concat(materialSnap.items["car_paint"])])

    
    // Traverse all and automatically build material color markings for pre-defined mats, todo later

    /* Working material inspector
    useLayoutEffect( () => {
      scene.traverse((obj) => obj.material !== undefined && console.log( obj.material.name))
    }, [scene])
    */
    
    //scene.traverse((obj) => obj.material !== undefined && console.log( obj.material.color) && obj.material.color.setHex(0))
    
    return (
      <group
        ref={group}
        {...props}
        dispose={null}
        onPointerOver={(e) => (e.stopPropagation(), set(e.object.material.name))}
        onPointerOut={(e) => e.intersections.length === 0 && set(null)}
        onPointerMissed={() => (state.current = null)}
        onPointerDown={(e) => (e.stopPropagation(), (state.current = e.object.material.name))}>
      <group name="Scene">
        <group rotation={[-Math.PI / 2, 0, 0]} position={0,0,-60}>
          <group rotation={[Math.PI / 2, 0, 0]}>
            <group position={[0, 97.05, 87.19]} rotation={[-1.58, 0, 0]} scale={100}>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh
                  geometry={nodes.bonnet01_Material__1829_0.geometry}
                  material={nodes.bonnet01_Material__1829_0.material}
                />
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh
                  geometry={nodes.bonnet02_Material__1829_0.geometry}
                  material={nodes.bonnet02_Material__1829_0.material}
                />
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh
                  geometry={nodes.bonnet03_Material__1829_0.geometry}
                  material={nodes.bonnet03_Material__1829_0.material}
                />
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh geometry={nodes.bonnet04_blue_0.geometry} material={materials.blue} />
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh geometry={nodes.bonnet08_Black_0.geometry} material={nodes.bonnet08_Black_0.material} />
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh geometry={nodes.bonnet10_black_m_0.geometry} material={nodes.bonnet10_black_m_0.material} />
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh geometry={nodes.bonnet11_gum_0.geometry} material={nodes.bonnet11_gum_0.material} />
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh geometry={nodes.bonnet16_kuzov_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh geometry={nodes.bonnet18_kuzov_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              </group>
              <group position={[0, 0.87, -1]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_bumper_10001_CarbonFiber_0.geometry}
                  material={nodes.Rear_bumper_10001_CarbonFiber_0.material}
                />
              </group>
            </group>
            <group position={[-0.26, 103.42, -169.02]} rotation={[-1.57, 0, 0]} scale={100}>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Front_bumper_12001_Chrome_0.geometry}
                  material={nodes.Front_bumper_12001_Chrome_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Front_bumper_12002_Chrome_0.geometry}
                  material={nodes.Front_bumper_12002_Chrome_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_bumper_10002_CarbonFiber_0.geometry}
                  material={nodes.Rear_bumper_10002_CarbonFiber_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_01_Chrome_0.geometry}
                  material={nodes.Rear_lights_trunk_01_Chrome_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_02_glass_0.geometry}
                  material={nodes.Rear_lights_trunk_02_glass_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh geometry={nodes.Rear_lights_trunk_03_10_0.geometry} material={materials.material_76} />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_04_Chrome_0.geometry}
                  material={nodes.Rear_lights_trunk_04_Chrome_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_05_r_glass_0.geometry}
                  material={nodes.Rear_lights_trunk_05_r_glass_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_06_Material__2013_0.geometry}
                  material={materials.Material__2013}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_06001_Material__2013001_0.geometry}
                  material={materials['Material__2013.001']}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_07_red001_0.geometry}
                  material={nodes.Rear_lights_trunk_07_red001_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_08_red_0.geometry}
                  material={nodes.Rear_lights_trunk_08_red_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_09_red_0.geometry}
                  material={nodes.Rear_lights_trunk_09_red_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_lights_trunk_10_red_0.geometry}
                  material={nodes.Rear_lights_trunk_10_red_0.material}
                />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh geometry={nodes.trunk_04_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh geometry={nodes.trunk_06_gum_0.geometry} material={nodes.trunk_06_gum_0.material} />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh geometry={nodes.trunk_08_Black_0.geometry} material={nodes.trunk_08_Black_0.material} />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh geometry={nodes.trunk_11_red_speed_0.geometry} material={materials.red_speed_77} />
              </group>
              <group position={[0, -1.69, -1.07]} scale={0.01}>
                <mesh geometry={nodes.trunk_14_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              </group>
            </group>
            <group position={[88.22, 39.34, 82.37]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
              <group position={[-0.89, 0.18, 0.62]} rotation={[3.13, 0, 0]} scale={-0.01}>
                <mesh geometry={nodes.Door_left_02_gum_0.geometry} material={nodes.Door_left_02_gum_0.material} />
              </group>
              <group position={[-0.91, 0.75, 0.16]} rotation={[0, 0, -Math.PI]} scale={[1.04, 1, 1]}>
                <mesh geometry={nodes.Door_left_03_Black_0.geometry} material={nodes.Door_left_03_Black_0.material} />
              </group>
              <group position={[-0.87, 0.76, 0.16]} rotation={[0, 0, -Math.PI]}>
                <mesh geometry={nodes.Door_left_04_Chrome_0.geometry} material={nodes.Door_left_04_Chrome_0.material} />
              </group>
              <group position={[-0.88, 0.82, -0.43]} rotation={[-0.01, 0, 0]} scale={0.01}>
                <mesh
                  geometry={nodes['Door_left_10_Material_#1048_0'].geometry}
                  material={nodes['Door_left_10_Material_#1048_0'].material}
                />
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh geometry={nodes.Door_left_11_Chrome_0.geometry} material={nodes.Door_left_11_Chrome_0.material} />
              </group>
              <group position={[-1.02, 0.58, 0.11]} rotation={[-0.68, 0.17, -3.06]} scale={[1.26, 1.17, 1]}>
                <mesh
                  geometry={nodes.Door_left_12_Salon_tex_0.geometry}
                  material={nodes.Door_left_12_Salon_tex_0.material}
                />
              </group>
              <group position={[-0.9, 0.75, 0.2]} rotation={[0, 0.06, -Math.PI]}>
                <mesh
                  geometry={nodes.Door_left_13_Salon_tex_0.geometry}
                  material={nodes.Door_left_13_Salon_tex_0.material}
                />
              </group>
              <group position={[-0.87, 0.76, 0.16]} rotation={[0, 0, -Math.PI]}>
                <mesh
                  geometry={nodes.Door_left_14_Salon_tex_0.geometry}
                  material={nodes.Door_left_14_Salon_tex_0.material}
                />
              </group>
              <group position={[-0.9, 0.75, 0.2]} rotation={[0, 0.06, 3.14]}>
                <mesh
                  geometry={nodes.Door_left_15_Salon_tex_0.geometry}
                  material={nodes.Door_left_15_Salon_tex_0.material}
                />
              </group>
              <group position={[-0.91, 0.75, 0.16]} rotation={[0, 0, -Math.PI]} scale={[1.04, 1, 1]}>
                <mesh
                  geometry={nodes.Door_left_16_Salon_tex_0.geometry}
                  material={nodes.Door_left_16_Salon_tex_0.material}
                />
              </group>
              <group position={[-0.88, 0.75, 0.16]} rotation={[0, 0, -Math.PI]}>
                <mesh
                  geometry={nodes.Door_left_17_Leather_0.geometry}
                  material={nodes.Door_left_17_Leather_0.material}
                />
              </group>
              <group position={[-1.02, 0.58, 0.11]} rotation={[-0.68, 0.17, -3.06]} scale={[1.26, 1.17, 1]}>
                <mesh geometry={nodes.Door_left_20_Black_0.geometry} material={nodes.Door_left_20_Black_0.material} />
              </group>
              <group position={[-0.2, 0.54, 0.46]} rotation={[-2.84, -1.37, 1.88]} scale={[0, 0, 0]}>
                <mesh geometry={nodes.Door_left_22_Chrome_0.geometry} material={nodes.Door_left_22_Chrome_0.material} />
              </group>
              <group position={[-0.88, 0.75, 0.16]} rotation={[0, 0, -Math.PI]}>
                <mesh
                  geometry={nodes.Door_left_23_Leather_0.geometry}
                  material={nodes.Door_left_23_Leather_0.material}
                />
              </group>
              <group position={[-0.15, 1.23, 0.58]} rotation={[-3.12, 0.09, 0]} scale={[0, 0, 0]}>
                <mesh
                  geometry={nodes.Door_left_24_black_m_0.geometry}
                  material={nodes.Door_left_24_black_m_0.material}
                />
              </group>
              <group position={[-0.87, 0.76, 0.16]} rotation={[0, 0, -Math.PI]}>
                <mesh
                  geometry={nodes.Door_left_25_Black001_0.geometry}
                  material={nodes.Door_left_25_Black001_0.material}
                />
              </group>
              <group position={[-0.91, 0.75, 0.16]} rotation={[0, 0, -Math.PI]} scale={[1.04, 1, 1]}>
                <mesh
                  geometry={nodes.Door_left_26_Black001_0.geometry}
                  material={nodes.Door_left_26_Black001_0.material}
                />
              </group>
              <group position={[-0.9, 0.75, 0.2]} rotation={[0, 0.06, -Math.PI]}>
                <mesh
                  geometry={nodes.Door_left_27_Black001_0.geometry}
                  material={nodes.Door_left_27_Black001_0.material}
                />
                <mesh
                  geometry={nodes['Door_left_27_Material_#1049_0'].geometry}
                  material={nodes['Door_left_27_Material_#1049_0'].material}
                />
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh geometry={nodes.Door_left_29_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_left_31_Material__0_0.geometry}
                  material={nodes.Door_left_31_Material__0_0.material}
                />
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh geometry={nodes.Door_left_33_chrome_0.geometry} material={nodes.Door_left_33_chrome_0.material} />
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_left_34_Material__0_0.geometry}
                  material={nodes.Door_left_34_Material__0_0.material}
                />
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_left_35_Material__0_0.geometry}
                  material={nodes.Door_left_35_Material__0_0.material}
                />
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh geometry={nodes.Door_left_36_glass_0.geometry} material={nodes.Door_left_36_glass_0.material} />
              </group>
              <group position={[8.09, -0.66, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_06001_kuzov_0.geometry}
                  material={custom["c" +materialSnap.items["car_paint"]]}
                  material-color={snap.items.car_paint}
                />
              </group>
              <group position={[-0.88, 1.11, 0.71]} rotation={[-0.01, 0, 0]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_22_d_glass_0.geometry}
                  material={custom["fsg" + materialSnap.items["front_side_glass"]]}
                  material-color={snap.items.front_side_glass}
                />
              </group>
              <group position={[-0.88, 0.84, 0.15]} rotation={[3.08, 0, -Math.PI]} scale={-1}>
                <mesh
                  geometry={nodes['interior_39002_Material_#1049001_0'].geometry}
                  material={nodes['interior_39002_Material_#1049001_0'].material}
                />
              </group>
              <group position={[-0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_bumper_10003_CarbonFiber_0.geometry}
                  material={nodes.Rear_bumper_10003_CarbonFiber_0.material}
                />
              </group>
              <group position={[-0.85, 0.98, 0.26]} rotation={[-0.09, 0, Math.PI]} scale={1.01}>
                <mesh geometry={nodes.seats_01001_Leather_0.geometry} material={nodes.seats_01001_Leather_0.material} />
              </group>
              <group position={[-0.53, 0.44, 0.47]} scale={0.01}>
                <mesh
                  geometry={nodes['Steering_wheel_03001_15_-_Default_0'].geometry}
                  material={nodes['Steering_wheel_03001_15_-_Default_0'].material}
                />
              </group>
              <group position={[-0.53, 0.43, 0.44]} scale={0.01}>
                <mesh
                  geometry={nodes.Steering_wheel_06001_Chrome001_0.geometry}
                  material={nodes.Steering_wheel_06001_Chrome001_0.material}
                />
              </group>
            </group>
            <group position={[-88.22, 39.34, 82.37]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
              <group
                name="Door_right_11"
                position={[0.9, 0.75, 0.2]}
                rotation={[-Math.PI, 0.06, 3.14]}
                scale={[-1, -1, -1]}>
                <mesh
                  geometry={nodes.Door_right_11_Salon_tex_0.geometry}
                  material={nodes.Door_right_11_Salon_tex_0.material}
                />
              </group>
              <group position={[0.9, 0.75, 0.2]} rotation={[-Math.PI, 0.06, 3.14]} scale={[-1, -1, -1]}>
                <mesh
                  geometry={nodes.Door_right_14_Black001_0.geometry}
                  material={nodes.Door_right_14_Black001_0.material}
                />
                <mesh
                  geometry={nodes['Door_right_14_Material_#1049_0'].geometry}
                  material={nodes['Door_right_14_Material_#1049_0'].material}
                />
              </group>
              <group position={[0.9, 0.75, 0.2]} rotation={[-Math.PI, 0.06, 3.14]} scale={[-1, -1, -1]}>
                <mesh
                  geometry={nodes.Door_right_19_Chrome_0.geometry}
                  material={nodes.Door_right_19_Chrome_0.material}
                />
              </group>
              <group position={[0.91, 0.74, 0.16]} rotation={[-Math.PI, 0, -Math.PI]} scale={[-1.04, -1, -1]}>
                <mesh geometry={nodes.Door_right_02_Black_0.geometry} material={nodes.Door_right_02_Black_0.material} />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh geometry={nodes.Door_right_04_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              </group>
              <group position={[9.85, -0.66, -0.43]} scale={0.01}>
                <mesh geometry={nodes.Door_right_06_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              </group>
              <group position={[0.89, 0.18, 0.62]} rotation={[-0.01, 0, 0]} scale={0.01}>
                <mesh geometry={nodes.Door_right_09_gum_0.geometry} material={nodes.Door_right_09_gum_0.material} />
              </group>
              <group position={[0.91, 0.74, 0.16]} rotation={[-Math.PI, 0, -Math.PI]} scale={[-1.04, -1, -1]}>
                <mesh
                  geometry={nodes.Door_right_10_Salon_tex_0.geometry}
                  material={nodes.Door_right_10_Salon_tex_0.material}
                />
              </group>
              <group position={[0.88, 0.75, 0.16]} rotation={[-Math.PI, 0, -Math.PI]} scale={-1}>
                <mesh
                  geometry={nodes.Door_right_12_Leather_0.geometry}
                  material={nodes.Door_right_12_Leather_0.material}
                />
              </group>
              <group position={[0.88, 0.75, 0.16]} rotation={[-Math.PI, 0, -Math.PI]} scale={-1}>
                <mesh
                  geometry={nodes.Door_right_13_Leather_0.geometry}
                  material={nodes.Door_right_13_Leather_0.material}
                />
              </group>
              <group position={[0.91, 0.74, 0.16]} rotation={[-Math.PI, 0, -Math.PI]} scale={[-1.04, -1, -1]}>
                <mesh geometry={nodes.Door_right_15_Black_0.geometry} material={nodes.Door_right_15_Black_0.material} />
              </group>
              <group position={[0.2, 0.54, 0.46]} rotation={[0.31, -1.37, 1.88]} scale={[0, 0, 0]}>
                <mesh
                  geometry={nodes.Door_right_20_Chrome_0.geometry}
                  material={nodes.Door_right_20_Chrome_0.material}
                />
              </group>
              <group position={[0.87, 0.76, 0.16]} rotation={[Math.PI, 0, -Math.PI]} scale={-1}>
                <mesh
                  geometry={nodes.Door_right_21_Black001_0.geometry}
                  material={nodes.Door_right_21_Black001_0.material}
                />
              </group>
              <group position={[0.88, 1.11, 0.71]} rotation={[-0.01, 0, 0]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_22001_d_glass_0.geometry}
                  material={custom["fsg" + materialSnap.items["front_side_glass"]]}
                  material-color={snap.items.front_side_glass}
                />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_23_Chrome_0.geometry}
                  material={nodes.Door_right_23_Chrome_0.material}
                />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_24_Material__0_0.geometry}
                  material={nodes.Door_right_24_Material__0_0.material}
                />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_26_Material__0_0.geometry}
                  material={nodes.Door_right_26_Material__0_0.material}
                />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_27_Material__0_0.geometry}
                  material={nodes.Door_right_27_Material__0_0.material}
                />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Door_right_29_chrome_0.geometry}
                  material={nodes.Door_right_29_chrome_0.material}
                />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh geometry={nodes.Door_right_30_glass_0.geometry} material={nodes.Door_right_30_glass_0.material} />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes['Door_right_31_Material_#1048_0'].geometry}
                  material={nodes['Door_right_31_Material_#1048_0'].material}
                />
              </group>
              <group position={[0.85, 0.65, 0.16]} rotation={[-Math.PI, 0, -Math.PI]} scale={[-0.92, -1, -1]}>
                <mesh
                  geometry={nodes['interior_109_Material_#1048_0'].geometry}
                  material={nodes['interior_109_Material_#1048_0'].material}
                />
              </group>
              <group position={[0.88, 0.84, 0.15]} rotation={[3.08, 0, -Math.PI]} scale={-1}>
                <mesh
                  geometry={nodes['interior_39001_Material_#1049001_0'].geometry}
                  material={nodes['interior_39001_Material_#1049001_0'].material}
                />
              </group>
              <group position={[0.88, 0.82, -0.43]} scale={0.01}>
                <mesh
                  geometry={nodes.Rear_bumper_10004_CarbonFiber_0.geometry}
                  material={nodes.Rear_bumper_10004_CarbonFiber_0.material}
                />
              </group>
              <group position={[0.92, 0.98, 0.26]} rotation={[-0.09, 0, Math.PI]} scale={1.01}>
                <mesh geometry={nodes.seats_01002_Leather_0.geometry} material={nodes.seats_01002_Leather_0.material} />
              </group>
              <group position={[1.23, 0.44, 0.47]} scale={0.01}>
                <mesh
                  geometry={nodes['Steering_wheel_03002_15_-_Default_0'].geometry}
                  material={nodes['Steering_wheel_03002_15_-_Default_0'].material}
                />
              </group>
              <group position={[1.23, 0.43, 0.44]} scale={0.01}>
                <mesh
                  geometry={nodes.Steering_wheel_06002_Chrome001_0.geometry}
                  material={nodes.Steering_wheel_06002_Chrome001_0.material}
                />
              </group>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.body_01_Material__720_0.geometry}
                material={nodes.body_01_Material__720_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_02_CarbonFiber_0.geometry} material={nodes.body_02_CarbonFiber_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_03_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.body_04_Material__720_0.geometry}
                material={nodes.body_04_Material__720_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_08_Material__1048001_0.geometry} material={materials['Material__1048.001']} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_09_Material__6_0.geometry} material={nodes.body_09_Material__6_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_11_glass_0.geometry} material={custom["fg" + materialSnap.items["front_glass"]]} material-color={snap.items.front_glass}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_12_Black_0.geometry} material={nodes.body_12_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.body_13_Material__720_0.geometry}
                material={nodes.body_13_Material__720_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_14_Material__1049_0.geometry} material={materials.Material__1049} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_15_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[Math.PI / 2, 0, 0]} scale={-1}>
              <mesh geometry={nodes.body_17_CarbonFiber_0.geometry} material={nodes.body_17_CarbonFiber_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_18_glass_0.geometry} material={custom["bg" + materialSnap.items["back_glass"]]} material-color={snap.items.back_glass}/>
              <mesh geometry={nodes.body_18_glass_0001.geometry} material={custom["bsg" + materialSnap.items["back_side_glass"]]} material-color={snap.items.back_side_glass} />
              <mesh geometry={nodes.body_18_glass_0002.geometry} material={custom["bsg" + materialSnap.items["back_side_glass"]]} material-color={snap.items.back_side_glass} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.body_19_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet00_black_m_0.geometry} material={nodes.bonnet00_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet05_black_m_0.geometry} material={nodes.bonnet05_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet06_black_m_0.geometry} material={nodes.bonnet06_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet09_silver_0.geometry} material={nodes.bonnet09_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet12_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet13_SilverMetal_0.geometry} material={nodes.bonnet13_SilverMetal_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet14_black_m_0.geometry} material={nodes.bonnet14_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet15_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.bonnet17_Black_0.geometry} material={nodes.bonnet17_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_01_2_0.geometry} material={nodes.buttom_01_2_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.buttom_02_Material__0_0.geometry}
                material={nodes.buttom_02_Material__0_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_03_silver_0.geometry} material={nodes.buttom_03_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_04_silver_0.geometry} material={nodes.buttom_04_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_05_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_10_wire_134110008_0.geometry} material={materials.wire_134110008} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_16_2_0.geometry} material={nodes.buttom_16_2_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_18_Chrome_0.geometry} material={nodes.buttom_18_Chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[Math.PI / 2, 0, 0]} scale={-1}>
              <mesh geometry={nodes.buttom_19_silver_0.geometry} material={nodes.buttom_19_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_22_black_m_0.geometry} material={nodes.buttom_22_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_23_gum_0.geometry} material={nodes.buttom_23_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_25_black_m_0.geometry} material={nodes.buttom_25_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_29_black_m_0.geometry} material={nodes.buttom_29_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.buttom_30_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[Math.PI / 2, 0, 0]} scale={-1}>
              <mesh geometry={nodes.buttom_31_plastic_0.geometry} material={nodes.buttom_31_plastic_0.material} />
            </group>
            <group position={[-2.78, 15.46, -23.18]} rotation={[1.49, -0.1, 0.09]} scale={[-91.9, -113.82, -113.81]}>
              <mesh
                geometry={nodes['Door_left_01_Material_#720_0'].geometry}
                material={nodes['Door_left_01_Material_#720_0'].material}
              />
            </group>
            <group position={[0, 55.6, 6.94]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={99.96}>
              <mesh
                geometry={nodes['Door_left_05_Material_#1049_0'].geometry}
                material={nodes['Door_left_05_Material_#1049_0'].material}
              />
            </group>
            <group position={[-7.43, 74.73, 20.64]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['Door_left_06_Material_#1048_0'].geometry}
                material={nodes['Door_left_06_Material_#1048_0'].material}
              />
            </group>
            <group position={[343.28, -3.19, 238.46]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Door_left_07_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              <mesh
                geometry={nodes['Door_left_07_Material_#1048_0'].geometry}
                material={nodes['Door_left_07_Material_#1048_0'].material}
              />
            </group>
            <group position={[0.05, 13.68, 11.03]} rotation={[-Math.PI / 2, 0, 0]} scale={[100.43, 93.95, 91.78]}>
              <mesh
                geometry={nodes['Door_left_21_Material_#720_0'].geometry}
                material={nodes['Door_left_21_Material_#720_0'].material}
              />
            </group>
            <group position={[0, -3.31, 0.73]} rotation={[-1.58, 0, 0]}>
              <mesh
                geometry={nodes['Door_left_28_Material_#1048_0'].geometry}
                material={nodes['Door_left_28_Material_#1048_0'].material}
              />
            </group>
            <group position={[1.69, 17.09, -24.36]} rotation={[-1.65, -0.1, 0.1]} scale={[92.2, 113.7, 113.68]}>
              <mesh
                geometry={nodes['Door_right_01_Material_#720_0'].geometry}
                material={nodes['Door_right_01_Material_#720_0'].material}
              />
            </group>
            <group position={[0, 55.6, 6.93]} rotation={[Math.PI / 2, 0, Math.PI]} scale={-99.96}>
              <mesh
                geometry={nodes['Door_right_03_Material_#1049_0'].geometry}
                material={nodes['Door_right_03_Material_#1049_0'].material}
              />
            </group>
            <group position={[897.07, -3.19, 148.77]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Door_right_05_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
              <mesh
                geometry={nodes['Door_right_05_Material_#1048_0'].geometry}
                material={nodes['Door_right_05_Material_#1048_0'].material}
              />
            </group>
            <group position={[-72.99, 96.98, -40.42]} rotation={[-1.52, 0.2, 0]} scale={[0.34, 0.34, 0.13]}>
              <mesh
                geometry={nodes.Door_right_08_black_m_0.geometry}
                material={nodes.Door_right_08_black_m_0.material}
              />
            </group>
            <group position={[0, -3.31, 0.73]} rotation={[1.56, 0, 0]} scale={-1}>
              <mesh
                geometry={nodes['Door_right_16_Material_#1048_0'].geometry}
                material={nodes['Door_right_16_Material_#1048_0'].material}
              />
            </group>
            <group position={[7.43, 74.73, 20.64]} rotation={[1.57, 0, 0]} scale={-1}>
              <mesh
                geometry={nodes['Door_right_17_Material_#1048_0'].geometry}
                material={nodes['Door_right_17_Material_#1048_0'].material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['engine_01_Material_#2152_0'].geometry}
                material={nodes['engine_01_Material_#2152_0'].material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_02_Black_0.geometry} material={nodes.engine_02_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['engine_03_Material_#2152_0'].geometry}
                material={nodes['engine_03_Material_#2152_0'].material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_04_CarbonFiber_0.geometry}
                material={nodes.engine_04_CarbonFiber_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_06_black_m_0.geometry} material={nodes.engine_06_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_07_black_m_0.geometry} material={nodes.engine_07_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_08_gum_0.geometry} material={nodes.engine_08_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_09_Black_0.geometry} material={nodes.engine_09_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_10_silver_0.geometry} material={nodes.engine_10_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_100_14_0.geometry} material={materials.material_9} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_101_Black_0.geometry} material={nodes.engine_101_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_102_black_m_0.geometry} material={nodes.engine_102_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['engine_103_Material_#2152_0'].geometry}
                material={nodes['engine_103_Material_#2152_0'].material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_106_Black_0.geometry} material={nodes.engine_106_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_11_black_m_0.geometry} material={nodes.engine_11_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_12_black_m_0.geometry} material={nodes.engine_12_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_13_gum_0.geometry} material={nodes.engine_13_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_14_gum_0.geometry} material={nodes.engine_14_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_15_1_0.geometry} material={materials.material_17} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_16_black_m_0.geometry} material={nodes.engine_16_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_17_black_m_0.geometry} material={nodes.engine_17_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_18_Black_0.geometry} material={nodes.engine_18_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_19_bump_metal_en_0.geometry}
                material={nodes.engine_19_bump_metal_en_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_20_SilverMetal_0.geometry}
                material={nodes.engine_20_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_21_bump_metal_en_0.geometry}
                material={nodes.engine_21_bump_metal_en_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_22_black_m_0.geometry} material={nodes.engine_22_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_23_Black_0.geometry} material={nodes.engine_23_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_24_Default_0.geometry} material={materials.Default} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_25_black_m_0.geometry} material={nodes.engine_25_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_26_Material__7_0.geometry}
                material={nodes.engine_26_Material__7_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_27_black_m_0.geometry} material={nodes.engine_27_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_28_black_m_0.geometry} material={nodes.engine_28_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_29_Material__7_0.geometry}
                material={nodes.engine_29_Material__7_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_30_Black_0.geometry} material={nodes.engine_30_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_31_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_32_Black_0.geometry} material={nodes.engine_32_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_33_Chrome_0.geometry} material={nodes.engine_33_Chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_34_Material__5_0.geometry} material={materials.Material__5} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_35_Chrome_0.geometry} material={nodes.engine_35_Chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_36_SilverMetal_0.geometry}
                material={nodes.engine_36_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_37_wire_176026026_0.geometry}
                material={nodes.engine_37_wire_176026026_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_38_silver_0.geometry} material={nodes.engine_38_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_39_Black_0.geometry} material={nodes.engine_39_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['engine_40_Material_#2152_0'].geometry}
                material={nodes['engine_40_Material_#2152_0'].material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_41_black_0.geometry} material={nodes.engine_41_black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_42_Black_0.geometry} material={nodes.engine_42_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_43_CarbonFiber_0.geometry}
                material={nodes.engine_43_CarbonFiber_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_44_chrome_0.geometry} material={nodes.engine_44_chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_45_chrome_0.geometry} material={nodes.engine_45_chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_46_silver_0.geometry} material={nodes.engine_46_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_47_silver_0.geometry} material={nodes.engine_47_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_48_Black_0.geometry} material={nodes.engine_48_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_49_silver_0.geometry} material={nodes.engine_49_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_50_Black_0.geometry} material={nodes.engine_50_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_51_gum_0.geometry} material={nodes.engine_51_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_52_SilverMetal_0.geometry}
                material={nodes.engine_52_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_53_gum_0.geometry} material={nodes.engine_53_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_54_gum_0.geometry} material={nodes.engine_54_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_57_gum_0.geometry} material={nodes.engine_57_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_59_CarbonFiber_0.geometry}
                material={nodes.engine_59_CarbonFiber_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_60_silver_0.geometry} material={nodes.engine_60_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_61_black_m_0.geometry} material={nodes.engine_61_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_62_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_63_black_0.geometry} material={nodes.engine_63_black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_64_black_0.geometry} material={nodes.engine_64_black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_65_black_m_0.geometry} material={nodes.engine_65_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_68_2_0.geometry} material={nodes.engine_68_2_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_69_black_m_0.geometry} material={nodes.engine_69_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_70_black_m_0.geometry} material={nodes.engine_70_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_71_black_m_0.geometry} material={nodes.engine_71_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_72_silver_0.geometry} material={nodes.engine_72_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_73_black_m_0.geometry} material={nodes.engine_73_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_75_black_m_0.geometry} material={nodes.engine_75_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_76_chrome_0.geometry} material={nodes.engine_76_chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_77_black_m_0.geometry} material={nodes.engine_77_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_78_Material__7_0.geometry}
                material={nodes.engine_78_Material__7_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_79_black_m_0.geometry} material={nodes.engine_79_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_80_black_m_0.geometry} material={nodes.engine_80_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_81_silver_0.geometry} material={nodes.engine_81_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_82_Chrome_0.geometry} material={nodes.engine_82_Chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_83_chrome_0.geometry} material={nodes.engine_83_chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_84_gum_0.geometry} material={nodes.engine_84_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.engine_86_SilverMetal_0.geometry}
                material={nodes.engine_86_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_87_Black_0.geometry} material={nodes.engine_87_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_88_Black_0.geometry} material={nodes.engine_88_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_89_silver_0.geometry} material={nodes.engine_89_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_90_black_0.geometry} material={nodes.engine_90_black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_91_gum_0.geometry} material={nodes.engine_91_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_92_red_0.geometry} material={nodes.engine_92_red_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_93_Material__985_0.geometry} material={materials.Material__985} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_94_black_m_0.geometry} material={nodes.engine_94_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_95_Black_0.geometry} material={nodes.engine_95_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_98_silver_0.geometry} material={nodes.engine_98_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.engine_99_black_0.geometry} material={nodes.engine_99_black_0.material} />
            </group>
            <group position={[-0.01, 58.12, -9.69]} rotation={[-Math.PI / 2, 0, 0]} scale={2.52}>
              <mesh
                geometry={nodes.Front_bumper_01_plastic_0.geometry}
                material={nodes.Front_bumper_01_plastic_0.material}
              />
            </group>
            <group position={[-0.01, 58.12, -9.69]} rotation={[-Math.PI / 2, 0, 0]} scale={2.52}>
              <mesh
                geometry={nodes.Front_bumper_02_Black_0.geometry}
                material={nodes.Front_bumper_02_Black_0.material}
              />
            </group>
            <group position={[-0.01, 58.12, -9.69]} rotation={[-Math.PI / 2, 0, 0]} scale={2.52}>
              <mesh
                geometry={nodes.Front_bumper_03_glass_0.geometry}
                material={nodes.Front_bumper_03_glass_0.material}
              />
            </group>
            <group position={[-0.01, 58.12, -9.69]} rotation={[-Math.PI / 2, 0, 0]} scale={2.52}>
              <mesh
                geometry={nodes.Front_bumper_04_glass_0.geometry}
                material={nodes.Front_bumper_04_glass_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_05_Material__2105_0.geometry}
                material={nodes.Front_bumper_05_Material__2105_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Front_bumper_06_Material__1_0.geometry} material={materials.Material__1} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_07_Black_0.geometry}
                material={nodes.Front_bumper_07_Black_0.material}
              />
              <mesh
                geometry={nodes.Front_bumper_07_Black_0001.geometry}
                material={nodes.Front_bumper_07_Black_0001.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Front_bumper_07001_Glass_0.geometry} material={materials.Glass} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_08_Material__0_0.geometry}
                material={nodes.Front_bumper_08_Material__0_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_10_Material__2105_0.geometry}
                material={nodes.Front_bumper_10_Material__2105_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_11_Chrome_0.geometry}
                material={nodes.Front_bumper_11_Chrome_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_12_Chrome_0.geometry}
                material={nodes.Front_bumper_12_Chrome_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_15_Black_0.geometry}
                material={nodes.Front_bumper_15_Black_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_16_Material__0_0.geometry}
                material={nodes.Front_bumper_16_Material__0_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_17_kuzov_0.geometry}
                material={custom["c" +materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_18_plastic_0.geometry}
                material={nodes.Front_bumper_18_plastic_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_19_plastic_0.geometry}
                material={nodes.Front_bumper_19_plastic_0.material}
              />
              <mesh
                geometry={nodes.Front_bumper_19_plastic_0001.geometry}
                material={nodes.Front_bumper_19_plastic_0001.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_20_plastic_0.geometry}
                material={nodes.Front_bumper_20_plastic_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_22_plastic_0.geometry}
                material={nodes.Front_bumper_22_plastic_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_23_plastic_0.geometry}
                material={nodes.Front_bumper_23_plastic_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_24_plastic_0.geometry}
                material={nodes.Front_bumper_24_plastic_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Front_bumper_27_glass_0.geometry}
                material={nodes.Front_bumper_27_glass_0.material}
              />
            </group>
            <group position={[-0.06, 32.99, -8.94]} rotation={[-1.67, 0, 0]} scale={[2.55, 2.55, 2.55]}>
              <mesh
                geometry={nodes.Front_bumper_28_Chrome_0.geometry}
                material={nodes.Front_bumper_28_Chrome_0.material}
              />
            </group>
            <group position={[-21.64, -3.19, 194.59]} rotation={[Math.PI / 2, 0, 0]} scale={-1}>
              <mesh
                geometry={nodes.Head_Lights_02_chrome_0.geometry}
                material={nodes.Head_Lights_02_chrome_0.material}
              />
            </group>
            <group position={[-73.29, 71.35, 230.36]} rotation={[Math.PI / 2, 0, 0]} scale={-1}>
              <mesh geometry={nodes.Head_Lights_04_Black_0.geometry} material={nodes.Head_Lights_04_Black_0.material} />
            </group>
            <group position={[61.24, 62.2, 205.35]} rotation={[-Math.PI, 0, 0]} scale={[-0.71, -0.71, -0.59]}>
              <mesh geometry={nodes.Head_Lights_05_glass_0.geometry} material={nodes.Head_Lights_05_glass_0.material} />
            </group>
            <group position={[-1.57, 63.65, 0.87]} rotation={[Math.PI / 2, 0, Math.PI]} scale={-95.67}>
              <mesh
                geometry={nodes.Head_Lights_06_d_glass_0.geometry}
                material={nodes.Head_Lights_06_d_glass_0.material}
              />
            </group>
            <group position={[1.57, 63.65, 0.87]} rotation={[-1.57, 0, Math.PI]} scale={95.67}>
              <mesh
                geometry={nodes.Head_Lights_12_black_m_0.geometry}
                material={nodes.Head_Lights_12_black_m_0.material}
              />
            </group>
            <group position={[1.57, 63.65, 0.87]} rotation={[-1.57, 0, Math.PI]} scale={95.67}>
              <mesh
                geometry={nodes.Head_Lights_13_d_glass_0.geometry}
                material={nodes.Head_Lights_13_d_glass_0.material}
              />
            </group>
            <group position={[1.57, 63.66, 0.87]} rotation={[-1.57, 0, Math.PI]} scale={95.67}>
              <mesh
                geometry={nodes.Head_Lights_14_black_m_0.geometry}
                material={nodes.Head_Lights_14_black_m_0.material}
              />
            </group>
            <group position={[-1.57, 63.65, 0.87]} rotation={[Math.PI / 2, 0, Math.PI]} scale={-95.67}>
              <mesh
                geometry={nodes.Head_Lights_16_black_m_0.geometry}
                material={nodes.Head_Lights_16_black_m_0.material}
              />
            </group>
            <group position={[1.57, 63.65, 0.87]} rotation={[-1.57, 0, Math.PI]} scale={95.67}>
              <mesh geometry={nodes.Head_Lights_18_Emission_0.geometry} material={materials.Emission} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Head_Lights_22_Chrome_0.geometry}
                material={nodes.Head_Lights_22_Chrome_0.material}
              />
            </group>
            <group position={[-1.56, 63.65, 0.87]} rotation={[Math.PI / 2, 0, -Math.PI]} scale={-95.67}>
              <mesh geometry={nodes.Head_Lights_23_glass_0.geometry} material={nodes.Head_Lights_23_glass_0.material} />
            </group>
            <group position={[45.34, 89.94, 59.79]} rotation={[-2.86, 0, -Math.PI]} scale={26.5}>
              <mesh
                geometry={nodes.interior_01_red_speed_0.geometry}
                material={nodes.interior_01_red_speed_0.material}
              />
            </group>
            <group position={[45.34, 89.94, 59.79]} rotation={[-2.86, 0, -Math.PI]} scale={26.5}>
              <mesh geometry={nodes['interior_02_Material_#166_0'].geometry} material={materials.Material_166} />
            </group>
            <group position={[45.34, 89.94, 59.79]} rotation={[-2.86, 0, -Math.PI]} scale={26.5}>
              <mesh
                geometry={nodes.interior_03_plastic001_0.geometry}
                material={nodes.interior_03_plastic001_0.material}
              />
            </group>
            <group position={[45.34, 89.94, 59.79]} rotation={[-2.86, 0, -Math.PI]} scale={26.5}>
              <mesh
                geometry={nodes['interior_04_Material_#1049_0'].geometry}
                material={nodes['interior_04_Material_#1049_0'].material}
              />
            </group>
            <group position={[0, 61.73, -201.97]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_05_Black_0.geometry} material={nodes.interior_05_Black_0.material} />
            </group>
            <group position={[0, 61.73, -202.76]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_06_Black_0.geometry} material={nodes.interior_06_Black_0.material} />
            </group>
            <group position={[0, 55.6, 6.56]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={99.96}>
              <mesh
                geometry={nodes['interior_08_Material_#1048_0'].geometry}
                material={nodes['interior_08_Material_#1048_0'].material}
              />
            </group>
            <group position={[34.96, 90.27, 57.59]} rotation={[-Math.PI / 2, 0, 0]} scale={1.01}>
              <mesh
                geometry={nodes['interior_09_Material_#1050001_0'].geometry}
                material={materials['Material_1050.001']}
              />
            </group>
            <group position={[-1.41, 73.72, 23.24]} rotation={[-1.3, 0, 0]} scale={1.22}>
              <mesh
                geometry={nodes['interior_10_Material_#1049_0'].geometry}
                material={nodes['interior_10_Material_#1049_0'].material}
              />
            </group>
            <group
              position={[-2.97, 55.6, 17.08]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[-92.03, -99.96, -99.96]}>
              <mesh
                geometry={nodes['interior_100_Material_#1049_0'].geometry}
                material={nodes['interior_100_Material_#1049_0'].material}
              />
            </group>
            <group position={[-7.96, 20.38, 55.31]} rotation={[-Math.PI, 0, -Math.PI]}>
              <mesh geometry={nodes.interior_101_Black_0.geometry} material={nodes.interior_101_Black_0.material} />
            </group>
            <group position={[0, 58.24, 4.97]} rotation={[-1.58, 0, -Math.PI]} scale={99.96}>
              <mesh
                geometry={nodes['interior_102_Material_#1048_0'].geometry}
                material={nodes['interior_102_Material_#1048_0'].material}
              />
            </group>
            <group position={[-11.37, 41.99, -62.66]} rotation={[0, 1.49, -2.63]} scale={[-52.7, -35.46, -29.01]}>
              <mesh
                geometry={nodes['interior_103_Material_#1048_0'].geometry}
                material={nodes['interior_103_Material_#1048_0'].material}
              />
            </group>
            <group position={[14.72, 41.99, -61.63]} rotation={[0.51, Math.PI / 2, 0]} scale={[52.7, 35.46, 29.01]}>
              <mesh
                geometry={nodes.interior_104_red_speed_0.geometry}
                material={nodes.interior_104_red_speed_0.material}
              />
            </group>
            <group
              position={[-2.97, 55.6, 17.08]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[-92.03, -99.96, -99.96]}>
              <mesh
                geometry={nodes['interior_105_Material_#1049_0'].geometry}
                material={nodes['interior_105_Material_#1049_0'].material}
              />
            </group>
            <group
              position={[-2.97, 55.6, 17.08]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[-92.03, -99.96, -99.96]}>
              <mesh geometry={nodes.interior_106_silver_0.geometry} material={nodes.interior_106_silver_0.material} />
            </group>
            <group position={[-7.96, 20.38, 55.31]} rotation={[-Math.PI, 0, -Math.PI]}>
              <mesh
                geometry={nodes.interior_108_SilverMetal_0.geometry}
                material={nodes.interior_108_SilverMetal_0.material}
              />
            </group>
            <group position={[75.09, 51.26, -5.66]} rotation={[1.58, 0, -Math.PI]} scale={[-117.32, -117.32, -117.32]}>
              <mesh
                geometry={nodes['interior_11_Material_#1048_0'].geometry}
                material={nodes['interior_11_Material_#1048_0'].material}
              />
            </group>
            <group
              position={[-2.97, 55.6, 17.08]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[-92.03, -99.96, -99.96]}>
              <mesh
                geometry={nodes['interior_110_Material_#1049_0'].geometry}
                material={nodes['interior_110_Material_#1049_0'].material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_111_Chrome_0.geometry} material={nodes.interior_111_Chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_113_Leather_0.geometry} material={nodes.interior_113_Leather_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['interior_114_Material_#1049_0'].geometry}
                material={nodes['interior_114_Material_#1049_0'].material}
              />
            </group>
            <group position={[-9.35, 126.88, 33.5]} rotation={[0, -0.06, 0]} scale={[0.41, 0.41, 0.32]}>
              <mesh geometry={nodes.interior_13_Black_0.geometry} material={nodes.interior_13_Black_0.material} />
              <mesh geometry={nodes.interior_13_gum_0.geometry} material={nodes.interior_13_gum_0.material} />
            </group>
            <group position={[-1.73, 28.5, 0.11]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={105.66}>
              <mesh geometry={nodes.interior_14_3_0.geometry} material={materials.material_52} />
            </group>
            <group position={[9.35, 126.88, 33.44]} rotation={[Math.PI, -0.06, 0]} scale={[-0.22, -0.22, -0.1]}>
              <mesh geometry={nodes.interior_15_glass_0.geometry} material={nodes.interior_15_glass_0.material} />
            </group>
            <group position={[0, 117.69, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh geometry={nodes.interior_17_12_0.geometry} material={materials.material_53} />
            </group>
            <group position={[-61.7, 26.78, -6.82]} rotation={[1.57, 0, 0]} scale={[-1, -0.91, -0.42]}>
              <mesh
                geometry={nodes['interior_18_Material_#1048_0'].geometry}
                material={nodes['interior_18_Material_#1048_0'].material}
              />
            </group>
            <group position={[0, 117.69, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh geometry={nodes['interior_19_Material_#1908_0'].geometry} material={materials.Material_1908} />
            </group>
            <group position={[-43.45, 100.28, -197.58]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_20_Black_0.geometry} material={nodes.interior_20_Black_0.material} />
            </group>
            <group position={[-58.53, 97, -187.56]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_21_gum_0.geometry} material={nodes.interior_21_gum_0.material} />
            </group>
            <group position={[-58.53, 97.78, -189.86]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_22_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[46.25, 250.8, -122.93]} rotation={[1.55, -0.13, 2.97]}>
              <mesh
                geometry={nodes['interior_23_Material_#1048_0'].geometry}
                material={nodes['interior_23_Material_#1048_0'].material}
              />
            </group>
            <group position={[34.67, 89.3, 61.84]} rotation={[1.57, 0, 0]} scale={[-1.01, -1.01, -0.9]}>
              <mesh
                geometry={nodes['interior_25_Material_#1048_0'].geometry}
                material={nodes['interior_25_Material_#1048_0'].material}
              />
            </group>
            <group position={[75.09, 51.26, -5.66]} rotation={[1.58, 0, -Math.PI]} scale={[-117.32, -117.32, -117.32]}>
              <mesh
                geometry={nodes['interior_27_Material_#1048_0'].geometry}
                material={nodes['interior_27_Material_#1048_0'].material}
              />
            </group>
            <group position={[34.85, 90.64, 54.49]} rotation={[1.57, 0, 0]} scale={[-1.01, -1.01, -0.9]}>
              <mesh
                geometry={nodes['interior_28_Material_#1048_0'].geometry}
                material={nodes['interior_28_Material_#1048_0'].material}
              />
            </group>
            <group position={[-7.96, 20.38, 55.31]} rotation={[-Math.PI, 0, -Math.PI]}>
              <mesh geometry={nodes.interior_30_Black_0.geometry} material={nodes.interior_30_Black_0.material} />
              <mesh
                geometry={nodes['interior_30_Material_#1048_0'].geometry}
                material={nodes['interior_30_Material_#1048_0'].material}
              />
            </group>
            <group
              position={[-2.97, 55.6, 17.08]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[-92.03, -99.96, -99.96]}>
              <mesh geometry={nodes.interior_31_Leather_0.geometry} material={nodes.interior_31_Leather_0.material} />
            </group>
            <group
              position={[-2.97, 55.51, 17.08]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[-92.03, -99.96, -90.19]}>
              <mesh
                geometry={nodes['interior_32_15_-_Default_0'].geometry}
                material={nodes['interior_32_15_-_Default_0'].material}
              />
            </group>
            <group position={[-1.14, 54.43, 1.16]} rotation={[1.5, 0, Math.PI]} scale={[-96.16, -99.96, -99.96]}>
              <mesh geometry={nodes.interior_33_Black_0.geometry} material={nodes.interior_33_Black_0.material} />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh geometry={nodes.interior_35_7_0.geometry} material={nodes.interior_35_7_0.material} />
            </group>
            <group position={[0, 58.24, 4.97]} rotation={[-1.58, 0, -Math.PI]} scale={99.96}>
              <mesh
                geometry={nodes['interior_36_Material_#1049_0'].geometry}
                material={nodes['interior_36_Material_#1049_0'].material}
              />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh geometry={nodes.interior_37_Black001_0.geometry} material={nodes.interior_37_Black001_0.material} />
            </group>
            <group position={[-8.26, 39.48, -112.51]} rotation={[1.58, -0.04, 3.06]} scale={[-99.96, -99.96, -99.96]}>
              <mesh
                geometry={nodes.interior_38_Salon_tex_0.geometry}
                material={nodes.interior_38_Salon_tex_0.material}
              />
            </group>
            <group position={[0, 54.27, -1.36]} rotation={[1.5, 0, Math.PI]} scale={-99.96}>
              <mesh
                geometry={nodes['interior_39_Material_#1049001_0'].geometry}
                material={nodes['interior_39_Material_#1049001_0'].material}
              />
            </group>
            <group position={[4.9, 88.62, 7.09]} rotation={[-1.58, Math.PI / 6, Math.PI]} scale={[99.96, 99.96, 99.96]}>
              <mesh geometry={nodes['interior_40_Material_#1051_0'].geometry} material={materials.Material_1051} />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[-0.02, Math.PI / 2, 0]}>
              <mesh geometry={nodes.interior_41_7_0.geometry} material={nodes.interior_41_7_0.material} />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh geometry={nodes.interior_42_Leather_0.geometry} material={nodes.interior_42_Leather_0.material} />
            </group>
            <group position={[-66.93, 58.24, 5.05]} rotation={[1.56, 0, -Math.PI]} scale={[-99.96, -99.96, -99.96]}>
              <mesh geometry={nodes.interior_43_17_0.geometry} material={nodes.interior_43_17_0.material} />
            </group>
            <group position={[-0.4, 55.6, 6.93]} rotation={[Math.PI / 2, 0, -Math.PI]} scale={-99.96}>
              <mesh
                geometry={nodes['interior_45_Material_#1048_0'].geometry}
                material={nodes['interior_45_Material_#1048_0'].material}
              />
              <mesh
                geometry={nodes.interior_45_plastic001_0.geometry}
                material={nodes.interior_45_plastic001_0.material}
              />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh
                geometry={nodes['interior_46_Material_#1048_0'].geometry}
                material={nodes['interior_46_Material_#1048_0'].material}
              />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh
                geometry={nodes['interior_47_Material_#1048_0'].geometry}
                material={nodes['interior_47_Material_#1048_0'].material}
              />
            </group>
            <group position={[-1.01, 54.21, 1.42]} rotation={[1.5, 0, Math.PI]} scale={[-96.16, -99.96, -99.96]}>
              <mesh
                geometry={nodes['interior_48_Material_#1048_0'].geometry}
                material={nodes['interior_48_Material_#1048_0'].material}
              />
            </group>
            <group
              position={[-2.97, 55.6, 17.08]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[-92.03, -99.96, -99.96]}>
              <mesh
                geometry={nodes['interior_50_Material_#1049_0'].geometry}
                material={nodes['interior_50_Material_#1049_0'].material}
              />
            </group>
            <group position={[-0.4, 55.6, 6.93]} rotation={[Math.PI / 2, 0, -Math.PI]} scale={-99.96}>
              <mesh geometry={nodes.interior_51_17_0.geometry} material={nodes.interior_51_17_0.material} />
            </group>
            <group position={[34.58, 42.62, 86.21]} rotation={[-2.85, 0, -Math.PI]} scale={[0.21, 0.21, 0.21]}>
              <mesh geometry={nodes.interior_52_Black_0.geometry} material={nodes.interior_52_Black_0.material} />
            </group>
            <group position={[0, 58.24, 4.97]} rotation={[-1.58, 0, -Math.PI]} scale={99.96}>
              <mesh geometry={nodes.interior_53_15_0.geometry} material={nodes.interior_53_15_0.material} />
            </group>
            <group position={[0, 58.24, 4.97]} rotation={[-1.58, 0, -Math.PI]} scale={99.96}>
              <mesh
                geometry={nodes['interior_54_Material_#1048_0'].geometry}
                material={nodes['interior_54_Material_#1048_0'].material}
              />
            </group>
            <group position={[24.41, 86.72, 59.03]} rotation={[-2.86, 0, Math.PI / 2]} scale={0.09}>
              <mesh
                geometry={nodes.interior_55_wait_spedometr_0.geometry}
                material={nodes.interior_55_wait_spedometr_0.material}
              />
            </group>
            <group
              position={[-4.9, 88.62, 7.09]}
              rotation={[1.56, Math.PI / 6, Math.PI]}
              scale={[-99.96, -99.96, -99.96]}>
              <mesh geometry={nodes.interior_56_Chrome_0.geometry} material={nodes.interior_56_Chrome_0.material} />
            </group>
            <group position={[2.97, 55.6, 17.08]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={[92.03, 99.96, 99.96]}>
              <mesh
                geometry={nodes['interior_57_Material_#1048_0'].geometry}
                material={nodes['interior_57_Material_#1048_0'].material}
              />
            </group>
            <group position={[-4.26, 72.48, 37.05]} rotation={[-0.01, 0, -Math.PI]} scale={[-26.96, -2.03, -26.96]}>
              <mesh geometry={nodes.interior_58_Black001_0.geometry} material={nodes.interior_58_Black001_0.material} />
            </group>
            <group position={[0, 55.38, 7.19]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={99.96}>
              <mesh
                geometry={nodes.interior_59_Salon_tex_0.geometry}
                material={nodes.interior_59_Salon_tex_0.material}
              />
            </group>
            <group position={[1.01, 54.08, 3.3]} rotation={[-1.58, 0, -Math.PI]} scale={[96.16, 99.96, 99.96]}>
              <mesh geometry={nodes.interior_60_Black_0.geometry} material={nodes.interior_60_Black_0.material} />
            </group>
            <group position={[-1.91, 57.1, 7.67]} rotation={[-1.59, 0.09, -3.05]} scale={[96.22, 99.93, 99.93]}>
              <mesh geometry={nodes.interior_61_Black_0.geometry} material={nodes.interior_61_Black_0.material} />
            </group>
            <group position={[0.39, 55.6, 7.06]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={99.96}>
              <mesh
                geometry={nodes['interior_62_Material_#1048_0'].geometry}
                material={nodes['interior_62_Material_#1048_0'].material}
              />
            </group>
            <group position={[2.79, 55.6, 17.08]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={[92.03, 99.96, 99.96]}>
              <mesh geometry={nodes.interior_63_8_0.geometry} material={materials.material_65} />
            </group>
            <group position={[39.4, 86.27, 58.33]} rotation={[-2.86, 0, -Math.PI]} scale={22.19}>
              <mesh
                geometry={nodes.interior_64_red_speed_0.geometry}
                material={nodes.interior_64_red_speed_0.material}
              />
            </group>
            <group position={[0, -3.31, 0.73]} rotation={[-1.58, 0, 0]}>
              <mesh geometry={nodes.interior_65_black_m_0.geometry} material={nodes.interior_65_black_m_0.material} />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh
                geometry={nodes.interior_67_Salon_tex_0.geometry}
                material={nodes.interior_67_Salon_tex_0.material}
              />
            </group>
            <group position={[0, 117.22, -0.92]} rotation={[3.13, Math.PI / 2, 0]} scale={[-1, -1, -1]}>
              <mesh geometry={nodes.interior_69_6_0.geometry} material={materials.material_66} />
            </group>
            <group position={[20.21, 88.6, 59.48]} rotation={[-2.86, 0, -0.44]} scale={[3.14, 1.26, 3.14]}>
              <mesh
                geometry={nodes.interior_70_red_speed_0.geometry}
                material={nodes.interior_70_red_speed_0.material}
              />
            </group>
            <group position={[45.34, 89.94, 59.79]} rotation={[-2.86, 0, -Math.PI]} scale={26.5}>
              <mesh
                geometry={nodes['interior_71_Material_#1048_0'].geometry}
                material={nodes['interior_71_Material_#1048_0'].material}
              />
            </group>
            <group position={[45.34, 89.87, 60.21]} rotation={[-2.86, 0, -Math.PI]} scale={[1.66, 1.66, 14.93]}>
              <mesh
                geometry={nodes['interior_73_Material_#1048_0'].geometry}
                material={nodes['interior_73_Material_#1048_0'].material}
              />
            </group>
            <group position={[45.34, 89.94, 59.79]} rotation={[-2.86, 0, -Math.PI]} scale={26.5}>
              <mesh
                geometry={nodes['interior_74_Material_#1048_0'].geometry}
                material={nodes['interior_74_Material_#1048_0'].material}
              />
            </group>
            <group position={[45.34, 89.94, 59.79]} rotation={[-2.86, 0, -Math.PI]} scale={26.5}>
              <mesh
                geometry={nodes['interior_75_Material_#1048_0'].geometry}
                material={nodes['interior_75_Material_#1048_0'].material}
              />
            </group>
            <group position={[19.74, 73.53, -45.16]} rotation={[1.8, 0.06, 2.52]} scale={[-99.96, -99.96, -99.96]}>
              <mesh
                geometry={nodes['interior_76_Material_#1048_0'].geometry}
                material={nodes['interior_76_Material_#1048_0'].material}
              />
            </group>
            <group position={[0, 50.67, 9.64]} rotation={[1.59, 0, Math.PI]} scale={[-99.96, -99.96, -99.96]}>
              <mesh
                geometry={nodes.interior_77_Salon_tex_0.geometry}
                material={nodes.interior_77_Salon_tex_0.material}
              />
            </group>
            <group position={[0, 58.24, 4.97]} rotation={[1.56, 0, -Math.PI]} scale={[-99.96, -99.96, -99.96]}>
              <mesh geometry={nodes.interior_78_black_m_0.geometry} material={nodes.interior_78_black_m_0.material} />
            </group>
            <group position={[0, 58.24, 1.85]} rotation={[-1.58, 0, -Math.PI]} scale={[99.96, 99.96, 99.96]}>
              <mesh geometry={nodes.interior_79_gum_0.geometry} material={nodes.interior_79_gum_0.material} />
            </group>
            <group position={[0, 63.27, -202.76]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_80_Black_0.geometry} material={nodes.interior_80_Black_0.material} />
            </group>
            <group position={[38.83, 96.66, -165.95]} rotation={[-Math.PI, 0.17, -Math.PI]} scale={[0.33, 0.22, 0.31]}>
              <mesh geometry={nodes.interior_81_Black_0.geometry} material={nodes.interior_81_Black_0.material} />
            </group>
            <group position={[0, 53.76, -14.81]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={[99.96, 84.96, 99.96]}>
              <mesh
                geometry={nodes['interior_82_Material_#1048_0'].geometry}
                material={nodes['interior_82_Material_#1048_0'].material}
              />
            </group>
            <group position={[46.25, 250.8, -122.93]} rotation={[1.55, -0.13, 2.97]}>
              <mesh
                geometry={nodes['interior_83_Material_#1048_0'].geometry}
                material={nodes['interior_83_Material_#1048_0'].material}
              />
            </group>
            <group position={[41.49, 72.66, -217.95]} rotation={[-Math.PI / 2, 0, 0]} scale={[0.37, 0.64, 0.64]}>
              <mesh
                geometry={nodes['interior_84_Material_#1048_0'].geometry}
                material={nodes['interior_84_Material_#1048_0'].material}
              />
            </group>
            <group position={[0, 61.73, -202.76]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.interior_85_Black_0.geometry} material={nodes.interior_85_Black_0.material} />
            </group>
            <group position={[50.13, 83.2, 48.51]} rotation={[-1.18, 0, 0]} scale={[0.77, 0.77, 0.77]}>
              <mesh
                geometry={nodes.interior_86_Material__9_0.geometry}
                material={nodes.interior_86_Material__9_0.material}
              />
            </group>
            <group position={[50.13, 83.2, 48.51]} rotation={[-1.18, 0, 0]} scale={[0.77, 0.77, 0.77]}>
              <mesh geometry={nodes.interior_87_silver_0.geometry} material={nodes.interior_87_silver_0.material} />
            </group>
            <group position={[44.43, 93.37, 60.84]} rotation={[-2.86, 0, -Math.PI]} scale={[0, 0, 0]}>
              <mesh
                geometry={nodes.interior_94_wait_spedometr_0.geometry}
                material={nodes.interior_94_wait_spedometr_0.material}
              />
            </group>
            <group position={[-4.26, 72.48, 37.05]} rotation={[-0.01, 0, -Math.PI]} scale={[-26.96, -2.03, -26.96]}>
              <mesh
                geometry={nodes['interior_95_Material_#104_Slot_#4001_0'].geometry}
                material={materials['Material_104_Slot_4.001']}
              />
            </group>
            <group position={[50.13, 83.2, 48.51]} rotation={[-1.18, 0, 0]} scale={[0.77, 0.77, 0.77]}>
              <mesh
                geometry={nodes['interior_96_Material_#1049_0'].geometry}
                material={nodes['interior_96_Material_#1049_0'].material}
              />
            </group>
            <group position={[-2.07, 94.49, 51.69]} rotation={[0.07, 0, -Math.PI]} scale={[-62.5, -62.5, -62.5]}>
              <mesh geometry={nodes.interior_97_Tab_0.geometry} material={materials.material_68} />
            </group>
            <group position={[0, 53.65, 0.87]} rotation={[1.58, 0, Math.PI]} scale={-99.96}>
              <mesh geometry={nodes.interior_98_silver_0.geometry} material={nodes.interior_98_silver_0.material} />
            </group>
            <group position={[-29.61, 299.4, 353.58]} rotation={[-1.39, 1.07, -0.78]} scale={[-3.47, -3.47, -3.47]}>
              <mesh geometry={nodes.mercedesbenz_Black_0.geometry} material={nodes.mercedesbenz_Black_0.material} />
            </group>
            <group position={[-43.69, -22.88, 17.73]} rotation={[-1.71, -0.47, 0.79]} scale={[2.59, 2.59, 2.59]}>
              <mesh geometry={nodes.multibeam_led_chrome_0.geometry} material={nodes.multibeam_led_chrome_0.material} />
            </group>
            <group rotation={[-1.58, 0, 0]}>
              <mesh geometry={nodes.Rear_bumper_01_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0.01, 28.05, -52.77]} rotation={[1.71, 0, 0]} scale={[-1.97, -1.97, -1.97]}>
              <mesh
                geometry={nodes.Rear_bumper_03_chrome_0.geometry}
                material={nodes.Rear_bumper_03_chrome_0.material}
              />
            </group>
            <group position={[0.01, 28.05, -52.77]} rotation={[1.71, 0, 0]} scale={-1.97}>
              <mesh
                geometry={nodes.Rear_bumper_04_black_m_0.geometry}
                material={nodes.Rear_bumper_04_black_m_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Rear_bumper_05_Material__0_0.geometry}
                material={nodes.Rear_bumper_05_Material__0_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[Math.PI / 2, 0, 0]} scale={-1}>
              <mesh
                geometry={nodes.Rear_bumper_06_CarbonFiber_0.geometry}
                material={nodes.Rear_bumper_06_CarbonFiber_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[Math.PI / 2, 0, 0]} scale={-1}>
              <mesh
                geometry={nodes.Rear_bumper_07_SilverMetal_0.geometry}
                material={nodes.Rear_bumper_07_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -26.81, -6.23]} rotation={[-1.46, 0, 0]}>
              <mesh
                geometry={nodes.Rear_bumper_08_black_m_0.geometry}
                material={nodes.Rear_bumper_08_black_m_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Rear_bumper_10_CarbonFiber_0.geometry}
                material={nodes.Rear_bumper_10_CarbonFiber_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Rear_bumper_11_5_0.geometry} material={materials.material_29} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Rear_bumper_12_Black_0.geometry} material={nodes.Rear_bumper_12_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Rear_bumper_13_gum_0.geometry} material={nodes.Rear_bumper_13_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Rear_bumper_14_chrome_0.geometry}
                material={nodes.Rear_bumper_14_chrome_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Rear_bumper_15_black_m_0.geometry}
                material={nodes.Rear_bumper_15_black_m_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Rear_bumper_17_r_glass_0.geometry}
                material={nodes.Rear_bumper_17_r_glass_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Rear_bumper_18_plastic_0.geometry}
                material={nodes.Rear_bumper_18_plastic_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.rear_lights_01_Chrome_0.geometry}
                material={nodes.rear_lights_01_Chrome_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.rear_lights_02_r_glass_0.geometry}
                material={nodes.rear_lights_02_r_glass_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.rear_lights_03_bump_metal_en_0.geometry}
                material={nodes.rear_lights_03_bump_metal_en_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.rear_lights_04_glass_0.geometry} material={nodes.rear_lights_04_glass_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.rear_lights_05_red_0.geometry} material={nodes.rear_lights_05_red_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.rear_lights_06_r_glass_0.geometry}
                material={nodes.rear_lights_06_r_glass_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.rear_lights_06001_glass001_0.geometry} material={materials['glass.001']} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.rear_lights_07_red001_0.geometry}
                material={nodes.rear_lights_07_red001_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.rear_lights_08_Chrome_0.geometry}
                material={nodes.rear_lights_08_Chrome_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.rear_lights_09_red_0.geometry} material={nodes.rear_lights_09_red_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.rear_lights_10_red_0.geometry} material={nodes.rear_lights_10_red_0.material} />
            </group>
            <group position={[3.46, 65.53, -15.53]} rotation={[-1.66, 0, Math.PI]} scale={101.13}>
              <mesh geometry={nodes.seats_01_Leather_0.geometry} material={nodes.seats_01_Leather_0.material} />
            </group>
            <group position={[3.43, 65.53, -15.28]} rotation={[-1.66, 0, Math.PI]} scale={[101.23, 101.13, 101.13]}>
              <mesh geometry={nodes.seats_02_17_0.geometry} material={nodes.seats_02_17_0.material} />
            </group>
            <group position={[3.46, 65.53, -15.52]} rotation={[-1.66, 0, Math.PI]} scale={101.13}>
              <mesh geometry={nodes.seats_03_15_0.geometry} material={nodes.seats_03_15_0.material} />
            </group>
            <group position={[3.46, 65.53, -15.52]} rotation={[-1.66, 0, Math.PI]} scale={[101.13, 101.13, 101.13]}>
              <mesh
                geometry={nodes['seats_05_Material_#1048_0'].geometry}
                material={nodes['seats_05_Material_#1048_0'].material}
              />
            </group>
            <group position={[-77.52, 65.53, -15.41]} rotation={[-1.66, 0, Math.PI]} scale={[101.13, 101.13, 101.13]}>
              <mesh geometry={nodes.seats_06_Salon_tex_0.geometry} material={nodes.seats_06_Salon_tex_0.material} />
            </group>
            <group position={[34.87, 86.36, 38.83]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['Steering_wheel_02_Material_#1048_0'].geometry}
                material={nodes['Steering_wheel_02_Material_#1048_0'].material}
              />
            </group>
            <group position={[34.87, 86.36, 38.83]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes['Steering_wheel_03_15_-_Default_0'].geometry}
                material={nodes['Steering_wheel_03_15_-_Default_0'].material}
              />
            </group>
            <group position={[34.87, 86.36, 38.83]} rotation={[1.57, 0, 0]} scale={-1}>
              <mesh geometry={nodes.Steering_wheel_04_18_0.geometry} material={materials.material_69} />
            </group>
            <group position={[34.87, 86.36, 38.83]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Steering_wheel_05_wire_176026026_0.geometry}
                material={nodes.Steering_wheel_05_wire_176026026_0.material}
              />
            </group>
            <group position={[34.87, 83.41, 39.25]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Steering_wheel_06_Chrome001_0.geometry}
                material={nodes.Steering_wheel_06_Chrome001_0.material}
              />
            </group>
            <group position={[34.87, 85.29, 42.63]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Steering_wheel_07_Salon_tex_0.geometry}
                material={nodes.Steering_wheel_07_Salon_tex_0.material}
              />
            </group>
            <group position={[22.23, 86.19, 36.51]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Steering_wheel_11_Salon_tex_0.geometry}
                material={nodes.Steering_wheel_11_Salon_tex_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.trunk_01_gum_0.geometry} material={nodes.trunk_01_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.trunk_02_Black_0.geometry} material={nodes.trunk_02_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.trunk_03_gum_0.geometry} material={nodes.trunk_03_gum_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.trunk_05_kuzov_0.geometry} material={custom["c" +materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}/>
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.trunk_07_Black_0.geometry} material={nodes.trunk_07_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.trunk_09_Black_0.geometry} material={nodes.trunk_09_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.trunk_10_Black_0.geometry} material={nodes.trunk_10_Black_0.material} />
            </group>
            <group position={[0, -6.22, 8.41]} rotation={[-Math.PI / 2, 0, 0]} scale={1.05}>
              <mesh geometry={nodes.trunk_13_Black_0.geometry} material={nodes.trunk_13_Black_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lb_01_Material__8_0.geometry}
                material={nodes.Wheel_lb_01_Material__8_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lb_02_Material__9_0.geometry}
                material={nodes.Wheel_lb_02_Material__9_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lb_03_wire_177028149_0.geometry}
                material={nodes.Wheel_lb_03_wire_177028149_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_04_9_0.geometry} material={nodes.Wheel_lb_04_9_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lb_05_Material__6_0.geometry}
                material={nodes.Wheel_lb_05_Material__6_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_06_11_0.geometry} material={nodes.Wheel_lb_06_11_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_07_silver_0.geometry} material={nodes.Wheel_lb_07_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_08_chrome_0.geometry} material={nodes.Wheel_lb_08_chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_09_rims_0.geometry} material={nodes.Wheel_lb_09_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_10_rims_0.geometry} material={nodes.Wheel_lb_10_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lb_11_SilverMetal_0.geometry}
                material={nodes.Wheel_lb_11_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_12_silver_0.geometry} material={nodes.Wheel_lb_12_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_13_silver_0.geometry} material={nodes.Wheel_lb_13_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lb_14_16_0.geometry} material={nodes.Wheel_lb_14_16_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_01_9_0.geometry} material={nodes.Wheel_lf_01_9_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lf_02_Material__8_0.geometry}
                material={nodes.Wheel_lf_02_Material__8_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lf_03_Material__9_0.geometry}
                material={nodes.Wheel_lf_03_Material__9_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lf_04_wire_184228153_0.geometry}
                material={nodes.Wheel_lf_04_wire_184228153_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lf_05_Material__6_0.geometry}
                material={nodes.Wheel_lf_05_Material__6_0.material}
              />
            </group>
            <group position={[0, -3.26, -0.01]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_06_chrome_0.geometry} material={nodes.Wheel_lf_06_chrome_0.material} />
            </group>
            <group position={[0, -3.26, -0.01]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_07_black_m_0.geometry} material={nodes.Wheel_lf_07_black_m_0.material} />
            </group>
            <group position={[0, -3.26, -0.01]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_08_4_0.geometry} material={nodes.Wheel_lf_08_4_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_09_rims_0.geometry} material={nodes.Wheel_lf_09_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_10_rims_0.geometry} material={nodes.Wheel_lf_10_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_11_silver_0.geometry} material={nodes.Wheel_lf_11_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_12_silver_0.geometry} material={nodes.Wheel_lf_12_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_lf_13_SilverMetal_0.geometry}
                material={nodes.Wheel_lf_13_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_lf_14_16_0.geometry} material={nodes.Wheel_lf_14_16_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rb_01_Material__8_0.geometry}
                material={nodes.Wheel_rb_01_Material__8_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rb_02_Material__9_0.geometry}
                material={nodes.Wheel_rb_02_Material__9_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rb_03_wire_177028149_0.geometry}
                material={nodes.Wheel_rb_03_wire_177028149_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_04_9_0.geometry} material={nodes.Wheel_rb_04_9_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rb_05_Material__6_0.geometry}
                material={nodes.Wheel_rb_05_Material__6_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_06_silver_0.geometry} material={nodes.Wheel_rb_06_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_07_11_0.geometry} material={nodes.Wheel_rb_07_11_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_08_chrome_0.geometry} material={nodes.Wheel_rb_08_chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_09_rims_0.geometry} material={nodes.Wheel_rb_09_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_10_rims_0.geometry} material={nodes.Wheel_rb_10_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_11_silver_0.geometry} material={nodes.Wheel_rb_11_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_12_silver_0.geometry} material={nodes.Wheel_rb_12_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rb_13_SilverMetal_0.geometry}
                material={nodes.Wheel_rb_13_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rb_14_16_0.geometry} material={nodes.Wheel_rb_14_16_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_01_9_0.geometry} material={nodes.Wheel_rf_01_9_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rf_02_Material__8_0.geometry}
                material={nodes.Wheel_rf_02_Material__8_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rf_03_Material__9_0.geometry}
                material={nodes.Wheel_rf_03_Material__9_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rf_04_wire_184228153_0.geometry}
                material={nodes.Wheel_rf_04_wire_184228153_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rf_05_Material__6_0.geometry}
                material={nodes.Wheel_rf_05_Material__6_0.material}
              />
            </group>
            <group position={[0, -3.19, 0.06]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_06_black_m_0.geometry} material={nodes.Wheel_rf_06_black_m_0.material} />
            </group>
            <group position={[0, -3.19, 0.06]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_07_chrome_0.geometry} material={nodes.Wheel_rf_07_chrome_0.material} />
            </group>
            <group position={[0, -3.19, 0.06]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_08_4_0.geometry} material={nodes.Wheel_rf_08_4_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_09_rims_0.geometry} material={nodes.Wheel_rf_09_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_10_rims_0.geometry} material={nodes.Wheel_rf_10_rims_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_11_silver_0.geometry} material={nodes.Wheel_rf_11_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes.Wheel_rf_12_SilverMetal_0.geometry}
                material={nodes.Wheel_rf_12_SilverMetal_0.material}
              />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_13_silver_0.geometry} material={nodes.Wheel_rf_13_silver_0.material} />
            </group>
            <group position={[0, -3.19, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.Wheel_rf_14_16_0.geometry} material={nodes.Wheel_rf_14_16_0.material} />
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}


useGLTF.preload("mercedes.glb")

export { Mercedes }